module.exports = __webpack_public_path__ + "img/login-bg.5825b791.png";